module.exports = __webpack_public_path__ + "img/iot3.b706e5b7.png";